import * as packageJSON from '../../package.json';

export const version = packageJSON.version;
